import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

// To check support for older iOS version
const hasHTMLDialog = typeof HTMLDialogElement === "function";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    insetInlineStart: 0,
    insetInlineEnd: 0,
    height: "fit-content",
    margin: "auto",
    overflow: "visible",
    outline: "none",
    background: theme.colors.Background4,
    borderRadius: theme.radius.medium,
    display: "none",
    flexDirection: "column",
    border: "none",
    maxWidth: 343,
    width: `calc(100% - ${theme.spacing.space16}px)`,
    padding: `${theme.spacing.space24}px ${theme.spacing.space16}px`,
    boxSizing: "border-box",
    "&::backdrop": {
      backgroundColor: `rgba(0,0,0, 0.7)`,
    },
    ...(hasHTMLDialog
      ? {
          "&[open]": {
            display: "flex",
          },
        }
      : {
          "&.open": {
            display: "flex",
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          },
        }),
  },
  icon: {
    height: 100,
    margin: "auto",
    overflow: "hidden",
    textAlign: "center",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  content: {
    textAlign: "center",
    overflow: "auto",
  },
  actions: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing.space16,
  },
}));
